import { render, staticRenderFns } from "./IntroHeaderMobile.vue?vue&type=template&id=36a737b4&"
var script = {}
import style0 from "./IntroHeaderMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports